import {
  deleteTenantProductPermanently
} from "./chunk-N6I6VNBJ.js";
import {
  ensureProductDataBag,
  getActiveCatalog,
  getTenantProductBySlug,
  loadTenantStore,
  saveTenantStore,
  userCatalogToCustomProducts
} from "./chunk-3TOUJ5O5.js";
import {
  brandToTenantRecord,
  definitionToTenantRecord,
  tenantRecordToDefinition
} from "./chunk-WAPZEZZJ.js";
import {
  customProductSlugFromSuffix,
  customSuffixCollidesWithBuiltInProduct
} from "./chunk-OENSNHCR.js";
import {
  runWithoutBuilderDevSync
} from "./chunk-UEG4HCRI.js";
import {
  registerProducts,
  unregisterProducts
} from "./chunk-6UZ4MMYO.js";

// src/tenant-products/catalog.ts
function listTenantProducts() {
  return getActiveCatalog(loadTenantStore());
}
function upsertUserTenantProductFromBrand(brand) {
  const slug = customProductSlugFromSuffix(brand.suffix);
  if (customSuffixCollidesWithBuiltInProduct(brand.suffix)) {
    const mirror2 = userCatalogToCustomProducts(loadTenantStore().catalog);
    return { index: Math.max(0, mirror2.length - 1), record: brandToTenantRecord(brand) };
  }
  const store = loadTenantStore();
  const existing = getTenantProductBySlug(store, slug);
  const record = existing ? {
    ...existing,
    brandSuffix: brand.suffix.trim(),
    brandColor: brand.brandColor,
    updatedAt: (/* @__PURE__ */ new Date()).toISOString(),
    source: "user"
  } : brandToTenantRecord({ suffix: brand.suffix, brandColor: brand.brandColor });
  const idx = existing ? store.catalog.findIndex((p) => p.id === existing.id) : store.catalog.length;
  if (existing) {
    store.catalog[idx] = record;
  } else {
    store.catalog.push(record);
    ensureProductDataBag(store, record.id);
  }
  saveTenantStore(store);
  registerProductsFromTenantStore();
  const mirror = userCatalogToCustomProducts(store.catalog);
  const index = mirror.findIndex(
    (cp) => cp.suffix.trim() === record.brandSuffix.trim()
  );
  return { index: index >= 0 ? index : mirror.length - 1, record };
}
function mergeCodeProductsIntoTenantStore(definitions) {
  const store = loadTenantStore();
  for (const def of definitions) {
    const existing = store.catalog.find((p) => p.id === def.id);
    if (existing?.source === "user") {
      const merged = definitionToTenantRecord(def, "code", {
        ...existing,
        brandSuffix: existing.brandSuffix,
        brandColor: existing.brandColor,
        nav: existing.nav
      });
      const idx2 = store.catalog.findIndex((p) => p.id === def.id);
      if (idx2 >= 0) store.catalog[idx2] = merged;
      continue;
    }
    const record = definitionToTenantRecord(def, "code", existing);
    const idx = store.catalog.findIndex((p) => p.id === def.id);
    if (idx >= 0) store.catalog[idx] = record;
    else {
      store.catalog.push(record);
      ensureProductDataBag(store, record.id);
    }
  }
  runWithoutBuilderDevSync(() => saveTenantStore(store));
}
function registerProductsFromTenantStore() {
  const catalog = listTenantProducts();
  if (catalog.length === 0) return;
  registerProducts(catalog.map(tenantRecordToDefinition));
}
function removeTenantProduct(productId) {
  deleteTenantProductPermanently(productId);
  unregisterProducts([productId]);
  registerProductsFromTenantStore();
  const store = loadTenantStore();
  return userCatalogToCustomProducts(store.catalog);
}
function updateTenantProductNav(productId, nav) {
  const store = loadTenantStore();
  const idx = store.catalog.findIndex((p) => p.id === productId && !p.deletedAt);
  if (idx < 0) return null;
  const current = store.catalog[idx];
  const next = {
    ...current,
    nav,
    updatedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
  store.catalog[idx] = next;
  saveTenantStore(store);
  registerProductsFromTenantStore();
  return next;
}
function syncCustomProductsMirror() {
  return userCatalogToCustomProducts(loadTenantStore().catalog);
}

export {
  listTenantProducts,
  upsertUserTenantProductFromBrand,
  mergeCodeProductsIntoTenantStore,
  registerProductsFromTenantStore,
  removeTenantProduct,
  updateTenantProductNav,
  syncCustomProductsMirror
};
